/**
 * Step 05 — Psychological Assessment
 *
 * Fields: mbtiType, oceanScores
 * Reuses the same MBTI + Big Five pattern from dating-schema.
 *
 * @module udp-schema/step-05
 */

import { z } from 'zod';

// ─── Main Step 05 Schema ────────────────────────────────────────────────────

export const step05PsychologicalSchema = z.object({
  /** MBTI type code (e.g., "INTJ", "ENFP") — derived from 4 binary questions */
  mbtiType: z.string().trim().max(4).optional(),

  /**
   * Big Five / OCEAN scores — 5 dimensions, each 1–100.
   * Same structure as dating-schema.
   */
  oceanScores: z
    .object({
      openness: z.number().min(1).max(100).optional(),
      conscientiousness: z.number().min(1).max(100).optional(),
      extraversion: z.number().min(1).max(100).optional(),
      agreeableness: z.number().min(1).max(100).optional(),
      neuroticism: z.number().min(1).max(100).optional(),
    })
    .optional(),
});

// ─── Inferred types ─────────────────────────────────────────────────────────

export type Step05PsychologicalInput = z.infer<typeof step05PsychologicalSchema>;
